export default __webpack_public_path__ + "img/invoice-icon1.194bb864.svg";